import { Vorgang, VorgangRechnungspositionEintrag } from '../types';
import { Gutachtenart, RECHNUNGSPOSITION_AUSWAHL, RECHNUNGSPOSITION_EINHEIT_AUSWAHL } from './constants';
import { MEHRWERTSTEUER } from './domain/vorgang';

const GUTACHTENARTEN_MIT_VORSTEUERHINWEIS: Gutachtenart[] = [
  Gutachtenart.SCHADENSGUTACHTEN_HAFTPFLICHT,
  Gutachtenart.SCHADENSGUTACHTEN_KASKO,
  Gutachtenart.KURZGUTACHTEN,
  Gutachtenart.REPARATURNACHWEIS
];

export const sollVorsteuerhinweisAngezeigtWerden = (vorgang: Pick<Vorgang, 'gutachtenart' | 'auftraggeberVorsteuerabzugsberechtigt'>): boolean =>
  Boolean(vorgang.auftraggeberVorsteuerabzugsberechtigt) && GUTACHTENARTEN_MIT_VORSTEUERHINWEIS.includes(vorgang.gutachtenart);

export const ermittleRechnungspositionLabel = (value: string) => {
  return RECHNUNGSPOSITION_AUSWAHL.find((rp) => rp.value === value)?.label ?? value;
};

export const ermittleRechnungspositionEinheit = (value: string) => {
  return RECHNUNGSPOSITION_EINHEIT_AUSWAHL.find((entry) => entry.value === value)?.label ?? value;
};

export const ermittleRechnungssummeNetto = (rechnungspositionen: VorgangRechnungspositionEintrag[]) => {
  return rechnungspositionen?.reduce((summe, rechnungsposition) => summe + rechnungsposition.summe, 0) ?? 0;
};

export const ermittleRechnungssummeMwSt = (rechnungspositionen: VorgangRechnungspositionEintrag[]) => {
  return (ermittleRechnungssummeNetto(rechnungspositionen) * (MEHRWERTSTEUER / 100)) / 100;
};
